module.exports = __webpack_public_path__ + "img/logo.bd67060d.png";